'use strict';

angular.module('imagetrend.components')
    .controller('hlpEducationReportController', ['$scope', '$rootScope', '$modal', 'Levels', '$window', 'Trainings',
        function ($scope, $rootScope, $modal, Levels, $window, Trainings) {
            $scope.expanded = true;
            $scope.expandedCourse = true;
            $scope.currentTopic = null;
            $scope.zero = "0.00";
            $scope.levelsLoading = false;

            var certificationLevel = "";
            var applicationType = "";
            for (var answer in $scope.datapointAnswers) {
                if (answer == "certification_levels" || $scope.datapointAnswers[answer][0].data_point_code == "certification_levels") {
                    certificationLevel = "datapointAnswers['" + answer + "']";
                }
                else if (answer == "certification_application_type" || $scope.datapointAnswers[answer][0].data_point_code == "certification_application_type") {
                    applicationType = "datapointAnswers['" + answer + "']";
                }
            }
            $scope.$watch(applicationType, function (type) {
                if (type != null) {
                    $scope.application_type = type[0].value;

                    if ($scope.certification_levels != null) {
                        $scope.levelsLoading = true;
                        var cl = $scope.certification_levels;
                        Levels.get({ certification_levels: $scope.certification_levels, application_type: $scope.application_type }).then(function (levels) {
                            if (cl == $scope.certification_levels) {
                                $scope.trainingLevels = levels;
                                if (!$scope.trainingsLoading) {
                                    $scope.calculateLevels();
                                }
                            }
                            $scope.levelsLoading = false;
                        })
                    }
                    else {
                        $scope.trainingLevels = [];
                    }
                }
            }, true)

            $scope.$watch(certificationLevel, function (levels) {

                if (levels != null) {
                    $scope.certification_levels = null;
                    levels.forEach(function (answer) {

                        if (answer.value != null && angular.isString(answer.value) && answer.value != '') {
                            answer.value.split(',').forEach(function (level) {

                                if ($scope.certification_levels == null) {
                                    $scope.certification_levels = level;
                                }
                                else {
                                    $scope.certification_levels += ',' + level;
                                }
                            })
                        }
                        else if (answer.value != null && angular.isArray(answer.value)) {
                            answer.value.forEach(function (level) {
                                if (level != null) {
                                    var l = null;
                                    if (angular.isObject(level)) {
                                        l = level.id;
                                    }
                                    else {
                                        l = level;
                                    }

                                    if (l != null) {
                                        if ($scope.certification_levels == null) {
                                            $scope.certification_levels = l;
                                        }
                                        else {
                                            $scope.certification_levels += ',' + l;
                                        }
                                    }
                                }
                            })
                        }
                    })

                    if ($scope.certification_levels != null) {
                        $scope.userProgress = null;
                        var cl = $scope.certification_levels;
                        if ($scope.application_type) {
                            $scope.levelsLoading = true;
                            Levels.get({ certification_levels: $scope.certification_levels, application_type: $scope.application_type }).then(function (levels) {
                                if (cl == $scope.certification_levels) {
                                    $scope.trainingLevels = levels;
                                    if (!$scope.trainingsLoading) {
                                        $scope.calculateLevels();
                                    }
                                }
                                $scope.levelsLoading = false;
                            })
                        }
                    }
                    else {
                        $scope.trainingLevels = [];
                    }
                }
            }, true)

            $scope.calculateLevels = function () {
                if ($scope.trainingLevels && $scope.trainingLevels.length > 0) {
                    $scope.levelsLoading = true;

                    var userID = null;
                    if ($scope.parameters.user_id) {
                        userID = $scope.parameters.user_id;
                    } else {
                        userID = $rootScope.userID;
                    }
                    Levels.getUserLevelProgress({ levelID: $scope.trainingLevels[0].id, userID: userID, applicationType: $scope.parameters.license_id, responseID: $scope.parameters.response_id }).then(function (userProgress) {
                        $scope.userProgress = userProgress;

                        //Calculate total required and completed hours
                        var totalRequired = 0;
                        var totalCount = 0;
                        if (userProgress.levelRequirementSummaries) {
                            for (var i = 0; i < userProgress.levelRequirementSummaries.length; i++) {
                                totalRequired += userProgress.levelRequirementSummaries[i].requiredHours || 0;
                                totalCount += userProgress.levelRequirementSummaries[i].completedHours || 0;
                            }
                            userProgress.levelTotalString = totalCount.toFixed(2).toString() + " of " + totalRequired.toFixed(2).toString();

                        }
                        $scope.levelsLoading = false;
                    });
                }
            }

            $scope.getWidth = function (levelRequirement) {
                var cHours = 0;
                var rHours = 0;

                cHours = levelRequirement.completedHours || 0;
                rHours = levelRequirement.requiredHours || 0;

                var per = (cHours / rHours) * 100;
                if (per > 100) {
                    per = 100;
                }
                var progressPer = "width: " + per.toString() + "%";
                return progressPer;
            }

            $scope.getRemainingHours = function (topic) {
                var required = 0;
                var completedHours = 0;
                var remainingHours = 0;

                required = topic.requiredHours || 0;
                completedHours = topic.completedHours || 0;
                remainingHours = required - completedHours;

                if (remainingHours < 0) {
                    remainingHours = 0;
                }
                return remainingHours.toFixed(2).toString();
            }

            $scope.openDocument = function (id, code) {
                if ($rootScope.isPortal && $rootScope.isPortal == "True") {
                    $window.open($rootScope.portalURL + 'controller.cfm?method=publicPortalService.openDocument' + '&documentID=' + id.toUpperCase() + '&code=' + code, '_blank');
                } else {
                    $window.open($rootScope.internalURL + 'controller.cfm?method=publicPortalService.openDocument' + '&documentID=' + id.toUpperCase() + '&code=' + code, '_blank');
                }
            }

            $scope.removeCourse = function (courseID) {
                $modal.open({
                    animation: true,
                    templateUrl: 'templates/confirm/confirm.html',
                    controller: 'ConfirmModalController',
                    resolve: {
                        message: function () {
                            return "Are you sure you want to remove this course?";
                        }
                    }
                }).result.then(function (result) {
                    if (result) {
                        if ($scope.parameters.user_id) {
                            Trainings.removeAttendeeFromCourse(courseID, [{ userId: $scope.parameters.user_id }]).then(function (result) {
                                $scope.calculateLevels();
                            });
                        }
                    }
                });
            }

            $scope.addCourse = function (topic) {

                $modal.open({
                    animation: true,
                    templateUrl: 'templates/supplemental-training-modal/education-report-modal.html',
                    controller: 'EducationReportModalController',
                    size: 'lg',
                    resolve: {
                        topic: topic,
                        parameters: $scope.parameters
                    }
                }).result.then(function (t) {
                    $scope.calculateLevels();
                })
            }

            $scope.checkCourseOptions = function (courses, option) {
                var checked = false;
                if (courses) {
                    courses.forEach(function (course) {
                        if (course.selectedOptions) {
                            var selectedOptions = course.selectedOptions.split(',');
                            selectedOptions.forEach(function (selectedOption) {
                                if (selectedOption.trim() == option.trim()) {
                                    checked = true;
                                }
                            })
                        }
                    })
                }
                return checked;
            }
        }])
    .directive('hlpEducationReport', [function () {
        return {
            restrict: 'E',
            templateUrl: 'templates/supplemental-training/education-report.html',
            replace: true,
            controller: 'hlpEducationReportController',
            scope: {
                parameters: '=?',
                component: '=?',
                datapointAnswers: '=?',
                pdf: '=?'
            },
            link: function (scope, elem, attrs, ctrl) {

            }
        };
    }])
;